// This code relies that the menu follows these accessibility practises:
// https://www.w3.org/TR/wai-aria-practices-1.1/examples/menu-button/menu-button-links.html

$(function () {

	Menus.attach();

	$('html').on("click", function (e) {
		Menus.closeAllMenus();
	});
});

$(document).on("mvvm:updated", function () {
	Menus.dettach();
	Menus.attach();
});

/**
 * @namespace
 * @global
 */
const Menus = {

	/** @type {Array.<{ $menu: JQuery, $button: JQuery, close: () => void, equals: (other: { $menu: JQuery, $button: JQuery }) => boolean }>} */
	openMenus: [],

	attach: function () {
		$('[aria-haspopup="true"]').on("keydown", Menus.onPopupButtonsKeyDown);
		$('[aria-haspopup="true"]').on("click", Menus.onPopupButtonsClick);
		$('[aria-haspopup="true"]').on("blur", Menus.onPopupButtonsBlur);	
		$('[aria-haspopup!="true"]').on("focus", Menus.onOtherElementsFocus);
	},

	dettach: function () {
		$('[aria-haspopup="true"]').off("keydown", Menus.onPopupButtonsKeyDown);
		$('[aria-haspopup="true"]').off("click", Menus.onPopupButtonsClick);
		$('[aria-haspopup="true"]').off("blur", Menus.onPopupButtonsBlur);	
		$('[aria-haspopup!="true"]').off("focus", Menus.onOtherElementsFocus);
	},

	onPopupButtonsKeyDown: function (e) {
		const spacebar = 32;
		const enter = 13;
		const downArrow = 40;
		if (e.target.tagName.toLowerCase() !== "button" && (e.which === spacebar || e.which === enter || e.which === downArrow)) {
			// For buttons these buttons trigger the click event so the menu gets toggled twice and in effect closes
			Menus.toggleMenu($(this));
			e.stopPropagation();
			e.preventDefault();
		}
	},

	onOtherElementsFocus: function (e) {
		Menus.closeMenusNotContaining(this);
	},

	onPopupButtonsClick: function (e) {
		e.preventDefault();
		e.stopPropagation();
		Menus.toggleMenu($(this));
	},

	onPopupButtonsBlur: function (e) {
		const $button = $(this);
	
		if (!$button.attr("aria-expanded")) {
			return;
		}

		const $menu = Menus.getMenu($button);
		if ($menu === null || $menu.length === 0)
			return;

		const relatedTarget = e.relatedTarget !== null ? e.relatedTarget : document.activeElement;
		if (relatedTarget !== null && ($menu[0] === relatedTarget || $.contains($menu[0], relatedTarget))) {
			return;
		}

		Menus.closeOpenMenu(Menus.findOpenMenu($menu));
	},

	closeAllMenus: function () {
		Menus.openMenus.forEach(function (item) {
			item.close();
		});
		Menus.openMenus = [];
	},
	/**
	 * Closes all open menus
	 * @param {Element} element 
	 */
	closeMenusNotContaining: function (element) {
		const menusToClose = Menus.openMenus.filter(function (item, index) {

			if (!$.contains(item.$menu[0], element) && !item.$menu.is(element)) {
				return true;
			}
			return false;
		});

		menusToClose.forEach(function (menu) {
			Menus.closeOpenMenu(menu);
		});
	},
	/**
	 * 
	 * @param {{ $menu: JQuery, $button: JQuery, close: () => void }} openMenu 
	 */
	closeOpenMenu: function (openMenu) {
		if (openMenu === null)
			return;
		Menus.openMenus.splice(Menus.openMenus.findIndex(function (value) {
			return value.equals(openMenu);
		}), 1);

		openMenu.close();
	},
	/**
	 * 
	 * @param {JQuery} $menu The menu element
	 * @returns {?{ $menu: JQuery, $button: JQuery, close: () => void }}
	 */
	findOpenMenu: function ($menu) {
		if ($menu.length === 0)
			return null;
		// console.log("Open menus count: " + Menus.openMenus.length);
		return Menus.openMenus.find(function (item) {
			return item.$menu.is($menu);
		});
	},
	/**
	 * Gets the menu controlled by the button
	 * @param {JQuery} $button 
	 * @returns {?JQuery}
	 */
	getMenu: function ($button) {
		const menuId = $button.attr("aria-controls");
		if (!menuId) {
			return null;
		}
		return $('#' + menuId);
	},
	/**
	 * Opens the menu controlled by the button
	 * @param {JQuery} $button 
	 */
	openMenu: function ($button)
	{
		const $menu = Menus.getMenu($button);
		if ($menu === null || $menu.length === 0)
			return;

		Menus.openMenus.push(Menus.createOpenMenu($menu, $button));
		$button.attr("aria-expanded", true);
		$button.addClass("menu-open");
		$menu.addClass("open");
		console.log($menu);

		const hideSelector = $button.attr("data-hide-selector");
		if (hideSelector !== "") {
			$(hideSelector).attr("aria-hidden", true);
		}

		const $menuItems = $menu.find("[role='menuitem']");
		if ($menuItems.length > 0) {
			$menuItems.first().trigger("focus");
		} else {
			$menu.trigger("focus");
		}
	},
	/**
	 * Opens the menu controlled by the button
	 * @param {JQuery} $button 
	 */
	toggleMenu: function ($button) {
		if (!$button.attr("aria-expanded")) {
			Menus.openMenu($button);
		} else {
			const menu = Menus.findOpenMenu(Menus.getMenu($button));
			if (menu !== null) {
				Menus.closeOpenMenu(menu);
			}
		}
	},
	/**
	 * 
	 * @param {JQuery} $menu 
	 * @param {JQuery} $button 
	 */
	createOpenMenu: function ($menu, $button) {
		return {
			$menu: $menu,
			$button: $button,
			close: function () {
				this.$menu.removeClass("open");
				this.$button.removeAttr("aria-expanded");
				this.$button.removeClass("menu-open");

				const hideSelector = $button.attr("data-hide-selector");
				if (hideSelector !== "") {
					$(hideSelector).attr("aria-hidden", false);
				}
			},
			/**
			 * 
			 * @param {{ $menu: JQuery, $button: JQuery }} other 
			 */
			equals: function (other) {
				return other !== null &&
					this.$menu !== null &&
					this.$button !== null &&
					this.$menu.is(other.$menu) &&
					this.$button.is(other.$button);
			}
		};
	},
}